import { Button } from "@dmca/frontend/components/button";
import { Input } from "@dmca/frontend/components/input";
import { Container, Stack } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "react-toastify";
import { fileToBase64 } from "@dmca/frontend/utils/file";

export const Route = createFileRoute(
  "/_authed/_drawerLayout/admin/plant/add-new"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { trpcQcProxy: trpc, qc } = Route.useRouteContext();
  const navigate = Route.useNavigate();
  const [plantNameValue, setPlantNameValue] = useState("");
  const [mapFile, setMapFile] = useState<File>();
  const [isDirty, setIsDirty] = useState(false);
  const uploadMutation = useMutation(trpc.plant.uploadMap.mutationOptions());
  const mutation = useMutation(
    trpc.plant.create.mutationOptions({
      onSuccess: async (data) => {
        let savedPlant = data;
        if (mapFile) {
          try {
            savedPlant = await uploadMutation.mutateAsync({
              plantId: data.id,
              expectedMapImageKey: data.mapImageKey,
              file: await fileToBase64(mapFile),
            });
          } catch (error) {
            console.error(error);
            toast.error(
              "Plant created, but the map upload failed. You can retry here."
            );
          }
        }
        qc.setQueryData(trpc.plant.getAll.queryKey(), (oldData) => {
          if (!oldData) return [savedPlant];
          return [...oldData, savedPlant];
        });
        navigate({
          to: "/admin/plant/$id",
          params: {
            id: data.id,
          },
        });
      },
      onError: (e) => {
        console.error(e);
        toast.error(
          "An unknown error occured. Please try again or contact support."
        );
      },
    })
  );
  return (
    <Container maxWidth="md">
      <Stack spacing={1} sx={{ height: "100%", mt: 1 }} component="form">
        <Input
          label="Plant Name"
          required
          value={plantNameValue}
          onChange={(e) => {
            setIsDirty(true);
            setPlantNameValue(e.target.value);
          }}
          error={isDirty && !plantNameValue.trim()}
          errorText="Plant name is required."
        />
        <Button component="label" variant="outlined">
          {mapFile ? mapFile.name : "Choose Map Image (Optional)"}
          <input
            hidden
            type="file"
            accept="image/png,image/jpeg,image/webp"
            onChange={(e) => setMapFile(e.target.files?.[0])}
          />
        </Button>
        <Button
          fullWidth
          disabled={
            !plantNameValue.trim() ||
            (!!mapFile && mapFile.size > 4 * 1024 * 1024)
          }
          loading={mutation.isPending || uploadMutation.isPending}
          type="submit"
          onClick={(e) => {
            e.preventDefault();
            mutation.mutate({
              name: plantNameValue,
            });
          }}
        >
          Submit
        </Button>
      </Stack>
    </Container>
  );
}
